import Vue from 'vue';

// local state
const getDefaultState = () => {
    return {
        update: {
            accessories: 0,
            configuration: 0,
        },
        reRender: 0,
        navigation: '',
        contentnav: 1,
        feldererstate:false,

        applocales: {
            available: {
                countries: [
                    'deu',
                    'fra',
                    'aut',
                    '___'],
                languages: [
                    'en',
                    'de',
                    'fr',
                    'ru',
                    'hu',
                    'tr',
                    'pl']
            },
            fallback: {
                country: 'deu',
                language: 'de'
            }
        }


    }
};

const state = getDefaultState()

const getters = {

};

const mutations = {

    updateUpdate(state, value) {
        state.update = value
    },
    updateReRender(state, value) {
        state.reRender = value
    },
    updateNavigation(state, value) {
        state.navigation = value
    },
    updateContentnav(state, value) {
        state.contentnav = value
    },
    updateAppLocales(value) {
        state.applocales=value
    },
    updateFeldererState(state, value) {
        state.feldererstate = value
    },
    resetState(state) {
        Object.assign(state, getDefaultState())
    },

};

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
